// 15 modules for the "Technology & Atmosphere" section
// Each module carries a matching photo drawn from the Innovation Tech brochures.

const IMG = {
  holographic:  "/generated/tech-tile-holographic.jpg",
  led:          "/generated/tech-tile-led-dance.jpg",
  interactive:  "/generated/tech-tile-interactive.jpg",
  aerial:       "/generated/tech-tile-aerial-mercedes.jpg",
  future:       "/generated/tech-tile-future-unleashed.jpg",
  silent:       "/generated/tech-tile-silent-future.jpg",
  brochure:     "/generated/tech-tile-lumiere-brochure.jpg",
};

export const TECH_MODULES = [
  {
    n: "01",
    title: "AI Mirror Experience",
    body:
      "Guests stand in front of an AI mirror and transform into futuristic avatars or the brand concept. Ideal for fashion, beauty, automotive, luxury hotels.",
    image: IMG.interactive,
  },
  {
    n: "02",
    title: "Projection Mapping Show",
    body:
      "Projection mapping on a car, building, yacht, stage, wedding cake or performer.",
    image: IMG.silent,
  },
  {
    n: "03",
    title: "Drone Light Show",
    body:
      "Instead of fireworks. Forms a logo, product, names or wedding monogram in the sky.",
    image: IMG.future,
  },
  {
    n: "04",
    title: "LED Dance Experience",
    body:
      "Dancers with LED costumes, programmable suits or pixel costumes that synchronize with music and graphics.",
    image: IMG.led,
  },
  {
    n: "05",
    title: "Hologram Performances",
    body:
      "Virtual singer, virtual CEO, virtual product reveal — parametric holograms in real scale.",
    image: IMG.holographic,
  },
  {
    n: "06",
    title: "Interactive Digital Floor",
    body:
      "LED floor that reacts to guests' footsteps. Ideal for gala, fashion show, product launch.",
    image: IMG.interactive,
  },
  {
    n: "07",
    title: "Kinetic Light Installation",
    body: "Moving lights in the air. Very high-end architectural moment.",
    image: IMG.future,
  },
  {
    n: "08",
    title: "Robotic Performers",
    body:
      "Robot dancers, robot bartenders, robot welcome hosts — for tech brands and future-forward events.",
    image: IMG.silent,
  },
  {
    n: "09",
    title: "Interactive AI Photo Experience",
    body:
      "It's not just a photobooth. The AI creates cinematic posters of the guest within the concept of the event.",
    image: IMG.brochure,
  },
  {
    n: "10",
    title: "Digital Art Tunnel",
    body:
      "Tunnel with projections, sound, sensors and light for a wow entrance.",
    image: IMG.interactive,
  },
  {
    n: "11",
    title: "Flying Performers + Mapping",
    body:
      "Aerial dancers with projection mapping on the costumes — moving canvases in the air.",
    image: IMG.aerial,
  },
  {
    n: "12",
    title: "Digital Rain Show",
    body:
      "LED curtains · Laser · Fog · Mirror effects. An immersive sensory downpour.",
    image: IMG.led,
  },
  {
    n: "13",
    title: "Motion Tracking Performance",
    body:
      "The performer's movements create light, particles or graphics in real time.",
    image: IMG.holographic,
  },
  {
    n: "14",
    title: "Interactive Product Reveal",
    body:
      "The product appears through lasers, holograms, mapping and performers. Ideal for launching a new product.",
    image: IMG.silent,
  },
  {
    n: "15",
    title: "Immersive Storytelling Experience",
    body:
      "It is not a simple event. The visitor goes through different chapters with actors, music, projection, scents, special effects and interactive installations — he lives a complete story.",
    image: IMG.future,
  },
];

export const TECH_MOCKUPS = [
  "/generated/immersive-1.png",
  "/generated/immersive-2.png",
  "/generated/immersive-3.png",
  "/generated/immersive-4.png",
  "/generated/immersive-5.png",
];

export const TECH_PERFECT =
  "Technology Brands · Automotive · Telecommunications · Fashion · Beauty · Luxury Hotels · Product Launches · Corporate Innovation Days";
